var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.positions),function(position){return _c('div',{key:position,class:'toast-container ' + position},[_vm._l((_vm.list),function(optionsArray,index){return [(optionsArray.position === position)?_c('vue-toastr',{key:index,attrs:{"data":optionsArray}}):_vm._e()]})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }